import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';

const FiltersTablePosts = ({ form, handleClear, setFormFilter, t, page, setPage }) => {
  
  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable handleClear={handleClear} multipleInput={true}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={form.title}
          label={t('titulo')}
          onChange={(e) => handleSearch(e, 'title')}
          placeholder={t('titulo')}
          md={7}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={form.author}
          label={t('autor')}
          onChange={(e) => handleSearch(e, 'author')}
          placeholder={t('autor')}
          md={7}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={form.body}
          label={t('body')}
          onChange={(e) => handleSearch(e, 'body')}
          placeholder={t('body')}
          md={7}
        />
      </Form>
    </SearchTable>
  )

};

FiltersTablePosts.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTablePosts
